import { createAction, props } from '@ngrx/store';
import { UserModel, ConfigurationModel } from './common.models';
//create a selection could be the right choice
//export const getConfiguration = createAction('[Configuration] get config');
export const loadConfiguration = createAction('[Configuration] load config');

export const loadConfigurationSuccess = createAction(
  '[Configuration] load config success',
  props<{ config: ConfigurationModel }>()
);
export const loadConfigurationError = createAction(
  '[Configuration] load config error',
  props<{ error: unknown }>()
);
export const loadUser = createAction(
  '[User] load user',
  props<{ token: string }>()
);

export const loadUserEntitlements = createAction(
  '[User] load user entitlements'
);

export const loadUserEntitlementsSuccess = createAction(
  '[User] load user entitlements success',
  props<{ entitlements: string[] }>()
);

export const loadUserSuccess = createAction(
  '[User] load user success',
  props<{ user: UserModel }>()
);
export const loadUserError = createAction('[User] load user error');
